import React from 'react';
import {
  Card, CardHeader, CardBody, Heading, Flex, Spinner, Text,
  useColorModeValue,
} from '@chakra-ui/react';
import {
  ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid,
  Tooltip, Legend,
} from 'recharts';

const TrendChart = ({ data, isLoading }) => {
  const cardBg = useColorModeValue('white', 'gray.700');

  return (
    <Card bg={cardBg} boxShadow="md">
      <CardHeader pb={2}>
        <Heading size="md">Tendência de Tickets</Heading>
      </CardHeader>
      <CardBody>
        {isLoading ? (
          <Flex justify="center" py={6}><Spinner /></Flex>
        ) : data.length === 0 ? (
          <Flex justify="center" py={6}><Text color="gray.500">Sem dados no período</Text></Flex>
        ) : (
          <ResponsiveContainer width="100%" height={280}>
            <LineChart data={data} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
              <XAxis
                dataKey="date"
                tick={{ fontSize: 12 }}
                tickFormatter={(val) => {
                  // Show shorter date labels
                  const parts = val.split('-');
                  return parts.length === 3 ? `${parts[2]}/${parts[1]}` : val;
                }}
              />
              <YAxis tick={{ fontSize: 12 }} allowDecimals={false} />
              <Tooltip
                labelFormatter={(val) => {
                  const parts = val.split('-');
                  return parts.length === 3 ? `${parts[2]}/${parts[1]}/${parts[0]}` : val;
                }}
              />
              <Legend />
              <Line
                type="monotone"
                dataKey="total"
                name="Total"
                stroke="#3182CE"
                strokeWidth={2}
                dot={{ r: 3 }}
                activeDot={{ r: 5 }}
              />
              <Line
                type="monotone"
                dataKey="resolved"
                name="Resolvidos"
                stroke="#38A169"
                strokeWidth={2}
                dot={{ r: 3 }}
                activeDot={{ r: 5 }}
              />
            </LineChart>
          </ResponsiveContainer>
        )}
      </CardBody>
    </Card>
  );
};

export default TrendChart;
